import { Link } from "@tanstack/react-router";
import { SIGN_UP_CTA } from "../lib/iteration-copy";
import { getIterationCountLabel } from "../lib/iteration-counter";
import { useBillingStatus } from "./BillingStatusContext";

/**
 * Header pill next to the logo showing a free user how much of this month's
 * allowance is left, with a CTA to /pricing. Appears only once the count is
 * low (see LOW_ITERATIONS_THRESHOLD) and stays visible at zero, so the upgrade
 * path is in the header exactly when it is worth acting on. Hidden for
 * subscribers, signed-out visitors, and while billing state loads.
 */
export function IterationCounter() {
  const { billingStatus, isBillingLoading } = useBillingStatus();
  const label = getIterationCountLabel(billingStatus, isBillingLoading);

  if (!label) return null;

  return (
    <div className="ml-4 hidden items-center gap-3 rounded-[36px] bg-[#262D34] py-1 pr-1 pl-5 sm:flex">
      <span className="whitespace-nowrap text-header-label text-(--text-secondary)">
        {label}
      </span>
      <Link
        to="/pricing"
        className="flex shrink-0 items-center justify-center gap-2.5 rounded-[36px] bg-[#3C7CA5] px-6 py-2 text-header-label text-(--text-primary)! no-underline transition-colors hover:bg-[#4a8db8]"
      >
        {SIGN_UP_CTA}
      </Link>
    </div>
  );
}
